import { render, staticRenderFns } from "./ShowActivityDetailsEve.vue?vue&type=template&id=06ff2e12&"
import script from "./ShowActivityDetailsEve.vue?vue&type=script&lang=js&"
export * from "./ShowActivityDetailsEve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports